// extracted by css-extract-rspack-plugin
export default {"emojiIcon":"emoji-module__emojiIcon__zcD5E","emojiContainer":"emoji-module__emojiContainer__INE1C"};